module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100 pos-r padding-referral has-text-left"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [(_vm.customReferralCode) ? [_vm._m(0), _c('div', {
    staticClass: "referral-code hint--right",
    class: {
      'fs-29': _vm.customReferralCode.length > 10
    },
    attrs: {
      "id": "referral_code",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.customReferralCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.customReferralCode))]), _c('div'), _c('div', {
    staticClass: "referral-link hint--right",
    attrs: {
      "id": "referral_link",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.customReferralLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.customReferralLink))]), _c('br')] : [_c('div', [_vm._v("Your Referral code:")]), _c('div', {
    staticClass: "referral-code hint--right",
    attrs: {
      "id": "referral_code",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.referralCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.referralCode))]), _c('div'), _c('div', {
    staticClass: "referral-link hint--right",
    attrs: {
      "id": "referral_link",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.referralLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.referralLink))])], _c('div', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("Share your referral code to  ")]), _c('b', [_c('a', {
    staticClass: "s12",
    attrs: {
      "href": "/referrals"
    }
  }, [_vm._v("earn " + _vm._s(_vm.customCodeTierPercentage || "0.25") + "% of your referral's mining rewards  ")])]), _c('span', [_vm._v(" , passively!")])]), (_vm.count === 0) ? [_c('span', [_vm._v("No workers are currently using your referral code!")])] : [_c('span', [_vm._v("There are currently ")]), _c('strong', {
    staticClass: "text-white-on-dark"
  }, [_vm._v(_vm._s(_vm.count) + " ")]), _c('span', [_vm._v("active worker")]), (_vm.count !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _c('span', [_vm._v(" using your referral code.")])], (_vm.customReferralCode) ? [_vm._m(1), _c('hr'), _c('div', [_c('span', [_vm._v("You are currently on ")]), _c('span', {
    staticClass: "tag tag-referral ml-0"
  }, [_vm._v(_vm._s(_vm.customCodeTierName) + " ")]), _c('span', [_vm._v(" ")]), _c('span', [_vm._v("earning ")]), _c('b', [_vm._v(_vm._s(_vm.customCodeTierPercentage) + "%  ")]), _c('span', [_vm._v("from your referral rewards.")])]), _c('ReferralCustomChart', {
    attrs: {
      "uuid": _vm.uuid
    }
  })] : _vm._e()], 2), (_vm.list.length > 0) ? _c('div', {
    staticClass: "column is-half"
  }, [(_vm.list.length > 0) ? [_c('table', {
    staticClass: "table is-fullwidth table"
  }, [_vm._m(2), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "w100 s12 w400"
    }, [_vm._v(_vm._s(item.name) + " ")])]), _c('td', {
      staticClass: "has-text-right"
    }, [_c('span', {
      staticClass: "w100 s12"
    }, [_vm._v(_vm._s(_vm._f("fromNow")(item.last_seen)) + " ")])])])
  }), 0)]), _c('div', {
    staticClass: "bottom-controls-payments"
  }, [(_vm.hasPrev) ? _c('div', {
    staticClass: "page-switch first hint--bottom-right",
    attrs: {
      "aria-label": "First page"
    },
    on: {
      "click": _vm.first
    }
  }, [_vm._m(3)]) : _vm._e(), (_vm.hasPrev) ? _c('div', {
    staticClass: "page-switch prev hint--bottom-right",
    attrs: {
      "aria-label": "Previous page"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._m(4)]) : _vm._e(), (_vm.hasNext) ? _c('div', {
    staticClass: "page-switch next hint--bottom-left",
    attrs: {
      "aria-label": "Next page"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._m(5)]) : _vm._e(), (_vm.hasNext) ? _c('div', {
    staticClass: "page-switch last hint--bottom-left",
    attrs: {
      "aria-label": "Last page"
    },
    on: {
      "click": _vm.last
    }
  }, [_vm._m(6)]) : _vm._e()])] : _vm._e()], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Your  ")]), _c('b', [_vm._v("Custom  ")]), _c('span', [_vm._v(" Referral code:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10 mb-10"
  }, [_c('span', [_vm._v("Note that using your own Custom Referral Code on your own workers won't work.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('span', [_vm._v("Referred worker")])]), _c('th', {
    staticClass: "has-text-right"
  }, [_c('span', [_vm._v("Last seen")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfbd3346","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_referral.vue
// module id = 392
// module chunks = 1